var map = {
	"./win-sign.png": 75,
	"./win-sign@2x.png": 76
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 127;


//////////////////
// WEBPACK FOOTER
// ./themes/fq/sprite ^\.\/win\-sign.*\.png$
// module id = 127
// module chunks = d-game